import moment from 'moment';
import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {inject, observer} from 'mobx-react';

import './Header.scss';

class Header extends Component {

  handleClick = () => {
    this.props.personaStore.resetPersona();
  }

  render() {
    const {
      count,
      created_at,
      id,
      inIframe,
      isEditable,
      updated_at,
      updatePersona,
    } = this.props.personaStore;
    const updateMessage = 'Last saved ' + moment(updated_at).format('HH:mm a');
    const countMessage = count === 1 ? 'Viewer or Editor' : 'Viewers & Editors';

    // If its in an iframe do not display header
    if (inIframe) return null;

    return (
      <nav className="navbar navbar-full navbar-dark" style={{backgroundColor: '#4A4A4A'}}>
        <Link className="navbar-brand" to="/" onClick={this.handleClick}>
          <img
            alt="PersonaGenerator Logo"
            className="d-inline-block align-top"
            height="30"
            src="/logo.svg"
            width="30"
          />
            &nbsp;Persona<strong>Generator</strong>
        </Link>
        {isEditable && (
          <form className="form-inline float-xs-left">
              <button className="btn btn-primary" type="button" onClick={updatePersona} disabled={!created_at}>
                <i className="fa fa-save"/>&nbsp; Save Changes
              </button>
              {updated_at && <span className="last-updated">{updateMessage}</span>}
          </form>
        )}
        {id && count > 0 && <span className="count"><strong>{count}</strong> {countMessage}</span>}
        <ul className="nav navbar-nav float-xs-right">
          <li className="nav-item">
            <Link className="nav-link" to="/"> Home </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/about"> About </Link>
          </li>
        </ul>
      </nav>
    );
  }
}

export default inject('personaStore')(observer(Header));



// WEBPACK FOOTER //
// ./client/components/Header.jsx